import React, { useEffect, useState, useRef } from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Calendar } from './Calendar';
interface DateInputProps {
  label: string;
  value: string; // YYYY-MM-DD format
  onChange: (value: string) => void;
  error?: boolean;
}
function formatToDisplay(isoDate: string): string {
  if (!isoDate || isoDate.length !== 10) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
}
function parseISODate(isoDate: string): Date {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day);
}
function formatToISO(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export function DateInput({
  label,
  value,
  onChange,
  error
}: DateInputProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const displayValue = formatToDisplay(value);
  const dateValue = parseISODate(value);
  const handleCalendarChange = (date: Date) => {
    onChange(formatToISO(date));
  };
  // Close calendar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);
  return <div ref={containerRef} data-id="element-44">
      <label className="block font-display text-xs uppercase tracking-wide text-[#1A1A1A] mb-2 font-bold" data-id="element-45">
        {label}
      </label>
      <div className="relative" data-id="element-46">
        <button type="button" onClick={() => setIsOpen(!isOpen)} className={`w-full bg-white border-2 rounded-none px-4 py-3 pr-12 text-sm text-[#1A1A1A] text-left focus:outline-none transition-all duration-100 ${error ? 'border-red-600 focus:border-red-600' : 'border-[#1A1A1A] focus:border-yellow focus:shadow-glow'}`} data-id="element-47">
          {displayValue || 'DD/MM/YYYY'}
        </button>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" data-id="element-48">
          <CalendarIcon className="w-5 h-5 text-purple" data-id="element-49" />
        </div>

        {isOpen && <Calendar value={dateValue} onChange={handleCalendarChange} onClose={() => setIsOpen(false)} data-id="element-50" />}
      </div>
    </div>;
}